import React from 'react';
import classNames from 'classnames';

import css from './Topbar.module.css';

/**
 * Shopping bag icon from the Figma navbar.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {string?} props.ariaLabel
 * @returns {JSX.Element}
 */
const BagIcon = props => {
  const { className, rootClassName, ariaLabel } = props;
  const classes = classNames(rootClassName || css.rootBagIcon, className);

  return (
    <svg
      className={classes}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}
    >
      <path
        d="M6.669 5.833h6.667c1.571 0 2.357 0 2.845.488.488.488.488 1.274.488 2.846v3.333c0 2.75 0 4.125-.854 4.979-.854.854-2.229.854-4.979.854H9.169c-2.75 0-4.125 0-4.979-.854-.854-.854-.854-2.229-.854-4.979V9.167c0-1.572 0-2.358.488-2.846.488-.488 1.274-.488 2.845-.488Z"
        stroke="currentColor"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.331 7.917c0-3.222-1.493-6.25-3.334-6.25-1.84 0-3.333 3.028-3.333 6.25"
        stroke="currentColor"
        strokeLinejoin="round"
        fill='none'
      />
    </svg>
  );
};

export default BagIcon;
